import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Diçka shkoi keq. Ju lutemi provoni përsëri.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Turns an axios error into a user-friendly string. Handles network / CORS
// failures where `err.response` is undefined — the case that produced the
// vague "Diçka shkoi keq" message on the live VPS.
export function formatAxiosError(err, fallback = "Diçka shkoi keq. Ju lutemi provoni përsëri.") {
  // Log the raw error for VPS debugging (visible in browser DevTools)
  try {
    // eslint-disable-next-line no-console
    console.error("[Akomoda API]", {
      message: err?.message,
      code: err?.code,
      status: err?.response?.status,
      data: err?.response?.data,
      url: err?.config?.url,
    });
  } catch (_) { /* noop */ }

  if (err?.response?.data?.detail) return formatApiErrorDetail(err.response.data.detail);
  // Backend returned a response but no `detail` (HTML from Nginx 502, etc.)
  if (err?.response) {
    return `Serveri u përgjigj me gabim (HTTP ${err.response.status}). Provoni pas pak.`;
  }
  if (err?.message === "Network Error" || err?.request) {
    return "Nuk arritëm të lidhemi me serverin. Kontrolloni lidhjen ose provoni pas pak.";
  }
  if (err?.code === "ECONNABORTED") {
    return "Kërkesa mori shumë kohë. Provoni përsëri.";
  }
  return fallback;
}
